<template>
  <div class="">
    <div class="breadcrumb-area pos-relative w-100">
      <h5 class="mb-0">Chi tiết yêu cầu đăng ký Combo bán hàng</h5>
      <div class="btn-group gap-2">
        <button class="btn btn-secondary" @click="goBack"><i class="bx bx-arrow-back"></i> Quay lại</button>
        <button v-if="canEdit && data?.createdBy === dataUser.agentId" class="btn btn-primary" @click="editCombo">
          Cập nhật
        </button>
        <button v-if="['REQUIRED'].includes(data?.status) && data?.createdBy === dataUser.agentId"
          class="btn btn-primary" @click="editComboAdditional">
          Cập nhật bổ sung
        </button>
        <button v-if="canEdit && data?.createdBy === dataUser.agentId" class="btn btn-danger" @click="showCancelModal">
          Hủy
        </button>
        <button v-if="['NEW', 'SUPPLEMENTED'].includes(data?.status) && data?.createdBy === dataUser.agentId"
          class="btn btn-warning" @click="showTransferPendingModal">
          Chuyển chờ xử lý
        </button>

      </div>
    </div>

    <div class="p-10 pt-15 b-t-1-869fb229">
      <b-overlay :show="loading" opacity="0.6" rounded="sm">
        <div class="mx-4 mt-2">
          <!-- Thông tin merchant -->
          <div class="row">
            <div class="col-md-5 px-2">
              <!-- <h6 class="font-weight-bold mb-3">Thông tin merchant</h6> -->

              <Card style="box-shadow: none; border: 1px solid #d7d7d7; margin-bottom: 20px" title="Thông tin yêu cầu"
                v-if="data">
                <Content title="Mã yêu cầu" :content="data.code || ''"></Content>
                <Content title="Thời gian tạo">
                  {{ formatDate(data.createdDate) }}
                </Content>
                <Content title="Trạng thái">
                  <span class="badge" :class="getStatusClass(data.status)">
                    {{ data.statusStr || data.status }}
                  </span>
                </Content>
                <Content title="Gói combo">
                  <span>
                    {{ getNameCombo || '' }}
                  </span>
                </Content>
                <Content title="Trạng thái thanh toán">
                  <span v-if="data.paymentStatusStr" class="badge" :class="getStatusClass(data.paymentStatusStr)">
                    {{ data.paymentStatusStr || data.paymentStatusStr }}
                  </span>
                </Content>
                <Content title="Trạng thái chữ ký số">
                  <span v-if="data.digitalSignatureRegistrationStatusStr" class="badge"
                    :class="getDigitalSignatureRegistrationStatus(data.digitalSignatureRegistrationStatus)">
                    {{ data.digitalSignatureRegistrationStatusStr || data.digitalSignatureRegistrationStatus }}
                  </span>
                </Content>
                <Content title="Trạng thái thẩm định CQ thuế">
                  <span v-if="data.taxAuthorityVerifyStatusStr" class="badge"
                    :class="getTaxAuthorityVerifyStatus(data.digitalSignatureRegistrationStatus)">
                    {{ data.taxAuthorityVerifyStatusStr || data.digitalSignatureRegistrationStatus }}
                  </span>
                </Content>

                <Content v-if="data.inviteCode" title="Mã giới thiệu" :content="data.inviteCode"></Content>
                <Content title="Ghi chú" :content="data.reason"></Content>
                <Content v-if="data.agentName" title="Agent" :content="data.agentName"></Content>
                <Content v-if="data.keeper && data.keeper.regionName" title="Khu vực" :content="data.keeper.regionName">
                </Content>
                <!-- Lý do yêu cầu bổ sung -->
                <div v-if="data?.supplementRequestReason">
                  <Content title="Lý do yêu cầu bổ sung" :content="data.supplementRequestReason"></Content>
                  <Content v-if="data?.supplementRequestNote" title="Ghi chú bổ sung"
                    :content="data?.supplementRequestNote"></Content>
                </div>

                <!-- Lý do từ chối yêu cầu -->
                <div v-if="data?.rejectionReason">
                  <Content title="Lý do từ chối yêu cầu" :content="data.rejectionReason"></Content>
                  <Content v-if="data?.rejectionNote" title="Ghi chú từ chối" :content="data.rejectionNote"></Content>
                </div>

                <!-- Lý do từ chối chữ ký số -->
                <div v-if="data?.digitalSignatureRejectionReason">
                  <Content title="Lý do từ chối chữ ký số" :content="data?.digitalSignatureRejectionReason"></Content>
                  <Content v-if="data?.digitalSignatureRejectionNote" title="Ghi chú từ chối chữ ký số"
                    :content="data?.digitalSignatureRejectionNote"></Content>
                </div>

                <!-- Lý do từ chối thẩm định CQ thuế -->
                <div v-if="data?.taxAuthorityRejectionReason">
                  <Content title="Lý do từ chối TĐ CQ thuế" :content="data?.taxAuthorityRejectionReason"></Content>
                  <Content v-if="data?.taxAuthorityRejectionNote" title="Ghi chú từ chối TĐ CQ thuế"
                    :content="data?.taxAuthorityRejectionNote"></Content>
                </div>
              </Card>

              <!-- Thông tin merchant -->
              <Card style="box-shadow: none; border: 1px solid #d7d7d7" title="Thông tin merchant" v-if="data">
                <Content title="Tên cửa hàng/Mc" :content="data?.merchantName || ''"></Content>
                <Content title="ĐKKD" :content="data?.businessRegistrationNumber || ''"></Content>
                <Content title="Địa chỉ" :content="data?.merchantAddress || ''"></Content>
                <Content v-if="data?.representativeName" title="Người chủ cửa hàng" :content="data?.representativeName">
                </Content>
                <Content v-if="data?.representativeEmail" title="Email người chủ cửa hàng"
                  :content="data?.representativeEmail">
                </Content>
                <Content v-if="data?.representativeMobile" title="SĐT người chủ cửa hàng"
                  :content="data?.representativeMobile">
                </Content>
                <Content v-if="data?.identityNumber" title="Số CCCD" :content="data?.identityNumber"></Content>
              </Card>

            </div>

            <!-- Ảnh & file đính kèm -->
            <div class="col-md-7 px-2">
              <Card style="box-shadow: none; border: 1px solid #d7d7d7; margin-bottom: 20px"
                title="Ảnh & file đính kèm">
                <!-- Ảnh giấy đăng ký kinh doanh -->
                <div class="attachment-group mt-4">
                  <label class="attachment-label">Ảnh giấy đăng ký kinh doanh:</label>
                  <div class="image-gallery"
                    v-if="data?.businessRegistrationNumberImages && data?.businessRegistrationNumberImages.length">
                    <div @click="viewImage(image, 'Ảnh giấy đăng ký kinh doanh ' + (index + 1))"
                      v-for="(image, index) in data?.businessRegistrationNumberImages" :key="'dkkd-' + index"
                      class="image-item">
                      <img :src="image" :alt="'ĐKKD ' + (index + 1)" class="clickable-image">

                      <div class="image-overlay">
                        <i class="fas fa-eye"></i>
                      </div>
                    </div>
                  </div>
                  <div v-else class="no-data">Chưa có ảnh</div>
                </div>

                <!-- Ảnh CCCD -->
                <div class="attachment-group">
                  <label class="attachment-label">Ảnh CCCD:</label>
                  <div class="image-gallery" v-if="data?.identityImages && data?.identityImages.length">
                    <div @click="viewImage(image, 'Ảnh CCCD ' + (index + 1))"
                      v-for="(image, index) in data?.identityImages" :key="'cccd-' + index" class="image-item">
                      <img :src="image" :alt="'CCCD ' + (index + 1)" class="clickable-image">
                      <div class="image-overlay">
                        <i class="fas fa-eye"></i>
                      </div>
                    </div>
                  </div>
                  <div v-else class="no-data">Chưa có ảnh </div>
                </div>

                <!-- File mẫu đăng ký CKS, đăng ký Combo Hóa đơn ĐT từ máy tính tiền PDF -->
                <div class="attachment-group">
                  <label class="attachment-label">File mẫu đăng ký CKS, đăng ký Combo Hóa đơn điện tử từ máy tính tiền
                  </label>
                  <div class="file-list" v-if="data?.contractFiles && data?.contractFiles.length">
                    <div v-for="(file, index) in data?.contractFiles" :key="'contract-' + index" class="file-item">
                      <div class="file-icon">
                        <i class="fas fa-file-pdf text-danger"></i>
                      </div>
                      <div class="file-info">
                        <!-- <div class="file-name">{{ getFileNameFromUrl(file) }}</div> -->
                        <i class='bx bxs-file-pdf ml-1 mt-4'
                          style="font-size: 50px; color: blue; text-align: center;"></i>
                        <div class="file-actions btn-group ">
                          <a :href="file" target="_blank" class="btn btn-sm ">
                            <i class='bx bx-download'></i>
                          </a>
                          <button @click="viewPDF(file)" class="btn btn-sm">
                            <i class='bx bx-show'></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="no-data">Chưa có file</div>
                </div>

                <!-- Ảnh mẫu đăng ký CKS, đăng ký Combo Hóa đơn ĐT từ máy tính tiền -->
                <div class="attachment-group">
                  <label class="attachment-label">Ảnh mẫu đăng ký CKS, đăng ký Combo Hóa đơn ĐT từ máy tính
                    tiền:</label>
                  <div class="image-gallery" v-if="data?.contractImages && data?.contractImages.length">
                    <div
                      @click="viewImage(image, 'Ảnh mẫu đăng ký CKS, đăng ký Combo Hóa đơn ĐT từ máy tính tiền ' + (index + 1))"
                      v-for="(image, index) in data?.contractImages" :key="'contract-img-' + index" class="image-item">
                      <img :src="image"
                        :alt="'mẫu đăng ký CKS, đăng ký Combo Hóa đơn ĐT từ máy tính tiền ' + (index + 1)"
                        class="clickable-image">
                      <div class="image-overlay">
                        <i class="fas fa-eye"></i>
                      </div>
                    </div>
                  </div>
                  <div v-else class="no-data">Chưa có ảnh</div>
                </div>

                <!-- Ghi chú (nếu có) -->
                <div class="attachment-group" v-if="data?.note">
                  <label class="attachment-label">Ghi chú:</label>
                  <div class="note-content">{{ data?.note }}</div>
                </div>
              </Card>
            </div>
          </div>
        </div>

        <div v-if="!data && !loading" class="text-center py-5">
          <i class="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
          <h5>Không tìm thấy dữ liệu</h5>
          <p class="text-muted">Vui lòng kiểm tra lại hoặc liên hệ quản trị viên</p>
        </div>
      </b-overlay>
    </div>

    <!-- Modal xem ảnh sử dụng b-modal -->
    <b-modal ref="imageModal" :title="currentImageTitle" size="lg" centered hide-footer body-class="p-0"
      @hidden="onModalHidden">
      <div class="image-modal-body">
        <img :src="currentImageUrl" :alt="currentImageTitle" class="modal-image">
      </div>
    </b-modal>

    <b-modal ref="transferPendingModal" title="Xác nhận chuyển chờ xử lý" @ok="confirmTransferPending"
      ok-title="Xác nhận" cancel-title="Hủy">
      <p>Bạn có chắc chắn muốn chuyển yêu cầu này sang trạng thái chờ xử lý không?</p>
    </b-modal>

    <!-- Thêm modal thông báo vào cuối template -->
    <b-modal size="xs" v-model="toastModal.show" scrollable centered title="Thông báo">
      <div class="modal-body text-center">
        <img v-if="toastModal.success" src="@/assets/img/noti-success2.svg" alt="icon-successs" />
        <img v-else src="@/assets/img/noti-unsuccess2.svg" alt="icon-unsuccesss" />
        <h2 class="f18 py-3">{{ toastModal.title }}</h2>
        <p class="text-center" style="font-size: 14px;">
          {{ toastModal.content }}
        </p>
      </div>
      <template #modal-footer="{ }">
        <button type="button" class="btn btn-light" @click="closeAdd()" data-dismiss="modal">
          Đóng
        </button>
      </template>
    </b-modal>

    <!-- Thêm modal xác nhận hủy vào cuối template -->
    <b-modal ref="cancelModal" title="Xác nhận hủy yêu cầu" @ok="confirmCancel" ok-title="Xác nhận"
      cancel-title="Không">
      <p>Bạn có chắc chắn muốn hủy yêu cầu này không?</p>
      <p class="text-warning">
        <i class="fas fa-exclamation-triangle"></i>
        <!-- <strong>Lưu ý:</strong> Hành động này không thể hoàn tác! -->
      </p>
    </b-modal>
  </div>
</template>

<script>
import { ComboService } from '../../services/combo.service'
import Content from '@/components/common/Content.vue'
import Card from '@/components/common/Card.vue'
import Config from '@/thirdParty/config'

export default {
  name: 'ComboRegistrationDetail',
  components: { Card, Content },
  data() {
    return {
      loading: false,
      data: null,
      comboId: this.$route.params.id,
      currentImageUrl: '',
      currentImageTitle: '',
      optionStatus: Config.optionStatusCombo,
      optionPaymentStatus: Config.optionPaymentStatusCombo,
      transferringToPending: false,
      toastModal: {
        show: false,
        success: true,
        title: '',
        content: ''
      },
      cancelling: false,
      dataUser: JSON.parse(localStorage.getItem('userData')),
      optionCombo: []
    }
  },

  computed: {
    canEdit() {
      // Có thể chỉnh sửa nếu trạng thái là draft hoặc rejected
      return this.data && ['NEW'].includes(this.data?.status)
    },
    getNameCombo() {
      return this.optionCombo?.find(e => e.id === this.data?.packageCode)?.text || ''
    }
  },

  async mounted() {
    await this.loadData()
    this.loadNameCombo()
  },

  methods: {
    async loadNameCombo(code) {
      try {
        const data = await ComboService.getPlaneServiceCommbo({
          page: 1,
          size: 1000
        })
        if (data.code === 1000) {
          const groupService = data.data?.groupService?.find(e => e.group === 'SELL')
          const comboService = groupService?.service?.find(e => e.code === 'COMBOSELL')
          const plans = comboService?.plan || []
          const newData = plans?.filter(e => Array.isArray(e?.partnerEnable) && e.partnerEnable.includes(`${this.dataUser?.partnerCode}_DIGITAL`)) || [];
          this.dataCombo = newData || []
          this.optionCombo = newData?.map(e => {
            return {
              id: e.code,
              text: e.title,
              partnerPrice: e.partnerPrice
            }
          }) || []
        }
      } catch (error) {
        console.log(error)
      }
    },
    getDigitalSignatureRegistrationStatus(status) {
      const map = Config.digitalSignatureRegistrationStatus?.reduce((acc, curr) => {
        acc[curr.id] = curr.bgColor
        return acc
      }, {})
      return map[status] || 'badge-secondary'
    },
    getTaxAuthorityVerifyStatus(status) {
      const map = Config.taxAuthorityVerifyStatus?.reduce((acc, curr) => {
        acc[curr.id] = curr.bgColor
        return acc
      }, {})
      return map[status] || 'badge-secondary'
    },
    showCancelModal() {
      this.$refs.cancelModal.show()
    },
    async confirmCancel() {
      try {
        this.cancelling = true

        const payload = {
          id: this.comboId,
          actionType: 'CANCEL'
        }

        const response = await ComboService.updateComboStatus(payload)

        if (response.code === 1000) {
          this.showToastModal(true, 'Thành công', 'Hủy yêu cầu thành công')
          // Reload data để cập nhật trạng thái mới
          await this.loadData()
        } else {
          this.showToastModal(false, 'Thất bại', response.message || 'Có lỗi xảy ra')
        }
      } catch (error) {
        console.error('Error cancelling request:', error)
        this.showToastModal(false, 'Lỗi', 'Có lỗi xảy ra khi hủy yêu cầu')
      } finally {
        this.cancelling = false
      }
    },
    closeAdd() {
      this.toastModal.show = false
    },

    showToastModal(success, title, content) {
      this.toastModal = {
        show: true,
        success: success,
        title: title,
        content: content
      }
    },
    showTransferPendingModal() {
      this.$refs.transferPendingModal.show()
    },

    async confirmTransferPending() {
      try {
        this.transferringToPending = true

        const payload = {
          id: this.comboId,
          actionType: 'TRANSFER_TO_PENDING'
        }

        const response = await ComboService.updateComboStatus(payload)

        if (response.code === 1000) {
          this.showToastModal(true, 'Thành công', 'Chuyển trạng thái thành công')
          // Reload data để cập nhật trạng thái mới
          await this.loadData()
        } else {
          this.showToastModal(false, 'Thất bại', response.message || 'Có lỗi xảy ra')
        }
      } catch (error) {
        console.error('Error transferring to pending:', error)
        this.showToastModal(false, 'Lỗi', 'Có lỗi xảy ra khi chuyển trạng thái')
      } finally {
        this.transferringToPending = false
      }
    },
    async loadData() {
      try {
        this.loading = true
        const response = await ComboService.detailCombo(this.comboId)

        if (response.code === 1000) {
          this.data = response.data
        } else {
          this.$toast.error(response.message || 'Không thể tải dữ liệu')
        }
      } catch (error) {
        console.error('Error loading data:', error)
        this.$toast.error('Có lỗi xảy ra khi tải dữ liệu')
      } finally {
        this.loading = false
      }
    },

    getStatusClass(status) {
      const map = this.optionStatus.reduce((acc, curr) => {
        acc[curr.id] = curr.bgColor
        return acc
      }, {})
      return map[status] || 'badge-secondary'
    },

    getPaymentStatusBadgeClass(paymentStatus) {
      const map = this.optionPaymentStatus.reduce((acc, curr) => {
        acc[curr.id] = curr.bgColor
        return acc
      }, {})
      return map[paymentStatus] || 'badge-secondary'
    },

    formatDate(dateString) {
      if (!dateString) return ''

      try {
        const date = new Date(dateString)
        return date.toLocaleString('vi-VN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        })
      } catch (error) {
        return 'Không hợp lệ'
      }
    },

    getFileNameFromUrl(url) {
      if (!url) return 'file.pdf'
      return url.split('/').pop() || 'file.pdf'
    },

    viewImage(imageUrl, title) {
      this.currentImageUrl = imageUrl
      this.currentImageTitle = title
      this.$refs.imageModal.show()
    },

    onModalHidden() {
      this.currentImageUrl = ''
      this.currentImageTitle = ''
    },

    viewPDF(pdfUrl) {
      window.open(pdfUrl, '_blank')
    },

    editCombo() {
      this.$router.push(`/sales-combos-edit/${this.comboId}`)
    },
    editComboAdditional() {
      this.$router.push(`/sales-combos-edit/${this.comboId}?action=SUPPLEMENTAL_UPDATE`)
    },

    goBack() {
      this.$router.push('/sales-combos')
    }
  }
}
</script>

<style scoped>
.breadcrumb-area {
  display: flex;
  height: 24px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.info-group {
  margin-bottom: 1rem;
}

.info-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.25rem;
  display: block;
}

.info-value {
  padding: 0.5rem 0.75rem;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  min-height: 38px;
  display: flex;
  align-items: center;
}

.attachment-group {
  margin-bottom: 2rem;
}

.attachment-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.75rem;
  display: block;
  font-family: sans-serif;
}

.image-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.image-item {
  position: relative;
  width: 120px;
  height: 120px;
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.image-item:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.image-item:hover .image-overlay {
  opacity: 1;
}

.clickable-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  color: white;
  font-size: 1.5rem;
}

.file-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.file-item {
  display: flex;
  align-items: center;
  padding: 1rem;
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  background: #f8f9fa;
  width: 125px;
  position: relative;
}

.file-icon {
  margin-right: 1rem;
  font-size: 2rem;
}

.file-info {
  flex: 1;
}

.file-name {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.file-actions {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
}

.no-data {
  padding: 2rem;
  text-align: center;
  color: #6c757d;
  width: 125px;
  background: #f8f9fa;
  border: 1px dashed #dee2e6;
  border-radius: 0.5rem;
  font-style: italic;
}

.note-content {
  padding: 1rem;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  white-space: pre-wrap;
  line-height: 1.6;
}

/* Modal xem ảnh với b-modal */
.image-modal-body {
  text-align: center;
  padding: 1rem;
}

.modal-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 0.5rem;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

/* Responsive */
@media (max-width: 768px) {
  .image-item {
    width: 100px;
    height: 100px;
  }

  .file-item {
    flex-direction: column;
    text-align: center;
  }

  .file-icon {
    margin-right: 0;
    margin-bottom: 0.5rem;
  }

  .breadcrumb-area {
    flex-direction: column;
    height: auto;
    gap: 1rem;
  }

  .breadcrumb-area>div {
    display: flex;
    gap: 0.5rem;
  }
}
</style>
